import dayjs from "dayjs";

// Hàm hỗ trợ tạo link chia sẻ hợp đồng
export const creatShareContractLink = (contractId: string) => {
// thời gian 2 ngày tới để chia sẻ hợp đồng (milisecond time)
	const NEXT_2_DAY = dayjs().add(2, "day").valueOf();
	return `${process.env.REACT_APP_PUBLIC_WEB_URL}/${contractId}/${NEXT_2_DAY + NEXT_2_DAY - 99999}`;
}